module.exports = __webpack_public_path__ + "fonts/subset-Axiforma-Italic.a0ac4b3.woff2";